module.exports = __webpack_public_path__ + "img/gb.c2c3cadc.svg";